export const initialValues: { [key: string]: { [key: string]: any } } = {
  source: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  projectFundingPercentage: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
      max: 100,
    },
  },
  rate: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
      max: 100,
    },
  },
  term: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  amount: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  eligibleCost: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  ineligibleCost: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  totalCost: {
    value: 0,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
    },
  },
};

export const tenantTypes = ['Retail', 'Office', 'Residential'];
export const sourcesWithOnlyAmountField = ['Façade Program Assistance', 'Owner Cash Investment'];
